<template>
    <div class='qualityAdd' >
        <div class="add" v-show="!isPreview">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm content">
                <el-form-item label="活动类别：" prop="type">
                    <el-select v-model="ruleForm.type" placeholder="请选择">
                        <el-option v-for="(item,index) in typeOption" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动名称：" prop="name">
                    <el-input v-model="ruleForm.name" placeholder="请输入活动名称"></el-input>
                </el-form-item>
                <el-form-item label="担任角色：" prop="role">
                    <el-select v-model="ruleForm.role" placeholder="请选择">
                        <el-option v-for="(item,index) in degreeOption" :label="item.label" :value="item.value" :key="index"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="活动时间：" >
                    <el-col :span="11" >
                        <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.startDate" style="width: 100%;"></el-date-picker>
                    </el-col>
                    <el-col :span="2" style="text-align: center">-</el-col>
                    <el-col :span="11">
                        <el-date-picker value-format="yyyy-MM-dd" type="date" placeholder="选择日期" v-model="ruleForm.endDate" style="width: 100%;"></el-date-picker>
                    </el-col>
                </el-form-item>

                <el-form-item label="组织单位：" prop="organizationalUnit" >
                    <el-input v-model="ruleForm.organizationalUnit" placeholder="请输入组织单位名称"></el-input>
                </el-form-item>
                <el-form-item label="负责教师：" prop="chargeTeacher">
                    <el-input v-model="ruleForm.chargeTeacher" placeholder="请输入负责教师"></el-input>
                </el-form-item>
                <div class="line">
                    上传相关图片：
                    <span>（2M以内，最多5张，支持jpg/png）</span>
                </div>
                <div>
                    <el-upload
                        :on-change="handleChange"
                        action="#"
                        :limit="5"
                        list-type="picture-card"
                        :auto-upload="false"
                        :file-list="ruleForm.fileList"
                        :on-preview="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :multiple="true"
                        accept="image/jpeg,image/jpg,image/png"
                    >
                        <i slot="default" class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogVisible">
                        <img width="100%" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </div>
            </el-form>
            <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
                <Button @handleClick="submitForm('ruleForm',true)" :type="'btnGray'" name="预览" ></Button>
                <Button @handleClick="submitForm('ruleForm',false)" :type="'btnBlue'" name="保存" ></Button>
            </div>
        </div>
        <div class="detail" v-show="isPreview">
            <QualityDetail :form="ruleForm"></QualityDetail>
            <div class="btnBox" style="display: flex;justify-content: space-around;padding: 45px 0px;width: 300px;margin: 0px auto;">
                <Button @handleClick="isPreview=false" :type="'btnGray'" name="返回" ></Button>
            </div>
        </div>
    </div>
</template>
<script>
import Button from '@/components/Button.vue';
import QualityDetail from '@/components/consultant/QualityDetail.vue';
export default {
    name: "qualityAdd",
    components: {
        Button,
        QualityDetail
    },
    data() {
        return {
            isPreview: false,
            typeOption: [
                { label: '研究性学习', value: '1' },
                { label: '大学先修课', value: '2' },
                { label: '社会实践', value: '3' },
                { label: '等级考试', value: '4' },
                { label: '高校营', value: '5' },
                { label: '其他类', value: '6' }
            ],
            degreeOption: [
                { label: '负责人', value: '1' },
                { label: '参与者', value: '2' },
                { label: '合作者', value: '3' },
                { label: '志愿者', value: '4' },
                { label: '作者', value: '5' },
                { label: '其他', value: '6' }
            ],
            personalTeamOption: [
                { label: '团体', value: '1' },
                { label: '个人', value: '2' }
            ],

            dialogImageUrl: '',
            dialogVisible: false,
            disabled: false,
            // file: null,
            isSave: false,

            previewVisible: false,
            previewImage: '',
            previewTitle: '',
            studentId: sessionStorage.getItem('myStudentStudentId'),
            ruleForm: {
                type: '',//1.研究性学习 2大学先修课 3社会实践 4等级考试 5高校营 6其他类
                name: '',//活动名称
                role: '',//担任角色
                startDate: null,//获奖日期
                endDate: null,//获奖日期
                organizationalUnit: '',//组织单位
                chargeTeacher: '',//负责教师
                picUrl: [],//上传图片

            },
            rules: {
                type: [
                    { required: true, message: '请选择竞赛类别', trigger: 'blur' },
                ],
                name: [
                    { required: true, message: '请输入赛事名称', trigger: 'blur' },
                ],
                role: [
                    { required: true, message: '请选择', trigger: 'blur' },
                ],
                organizationalUnit: [
                    { required: true, message: '请输入组织单位名称', trigger: 'blur' },
                ],
                chargeTeacher: [
                    { required: true, message: '请选择奖项类型', trigger: 'blur' },
                ],
                // datapicker:[
                //     {
                //         required: true, message: '请选择时间节点'
                //     }
                // ]
            },
            isbtn:true


        }
    },
    methods: {
        handleChange(file, fileList) {
            // console.log(file,fileList)
            // console.log(this.ruleForm)
            this.ruleForm.picUrl = fileList;
        },
        handleRemove(file,fileList) {
            // console.log(file,fileList);
            this.ruleForm.picUrl = fileList;
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        submitForm(formName, isPreview) {

            if(!this.isbtn){
                this.$message({
                    message: '请勿重复提交',
                    type: 'error'
                });
                
                return false
            }

            this.isbtn = false





            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const obj = {...this.ruleForm};
                    obj.studentId = this.studentId;
                    if(!isPreview) {
                        let { studentId,type,name,role,startDate,endDate,organizationalUnit,chargeTeacher,picUrl } = obj;
                        let params = new FormData();
                        params.append("studentId",studentId);
                        params.append("type",type);
                        params.append("name",name);
                        params.append("role",role);
                        params.append("startDate",startDate);
                        params.append("endDate",endDate);
                        params.append("organizationalUnit",organizationalUnit);
                        params.append("chargeTeacher",chargeTeacher);
                        picUrl&&picUrl.forEach((value, index) =>{
                            params.append(`picUrl[${index}]`,value.raw);
                        })
                        // 存储综合素质信息
                        this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.quality.storeComplexQuality, params, {
                            headers: {
                                token: window.sessionStorage.getItem('ymtxToken')
                            }
                        }).then((res) => {
                            if (res.data.code == 2000) {
                                this.isbtn = true;
                                let id = res.data.data.id;
                                this.$router.replace({path:'/consultant/minestudent/main/studentMessage/quality/detail',query:{id: id}})
                            }else{
                                    this.isbtn = true;
                                    this.$message({
                                    message: '请检查图片是否符合',
                                    type: 'error'
                                    });

                                }
                        })
                        .catch((error) => {
                                 this.isbtn = true;
                                    this.$message({
                                    message: '请检查图片是否符合',
                                    type: 'error'
                                    });

                             }) 
                    }else {
                        this.isPreview = true;
                        console.log(this.ruleForm)
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    },
}
</script>

<style scoped lang="less">
.qualityAdd {
    .content {
        padding: 0 30px 30px 30px;
        background-color: #fff;
    }
    .line {
        margin-bottom: 20px;
    }
}
</style>
<style lang="less">
.qualityAdd {
    input {
        border: 1px solid #EAEAEA;
        background-color: #FDFDFD;
    }
    .el-form-item {
        width: 410px;
        .el-select {
            width: 100%;
        }
    }
}
</style>